import React from 'react'

function TodosError() {
  return <p>An error has ocurred</p>;
}

export { TodosError }